<template>
  <div class="home-view" v-if="!isLoading">
    <template v-if="!isLoading && !errorMessage">
      <NewsCarousel :slides="carouselNews" />
      <NewsGrid 
        :news="allNews" 
        :category="null"
        title="Todas as Notícias"
        :itemsPerPage="9"
      />
    </template>
    <div v-else-if="!isLoading && errorMessage" class="home-error">
      <h2>Não foi possível carregar as notícias agora.</h2>
      <p>Tente recarregar a página em alguns instantes.</p>
      <button class="retry-btn" @click="loadNews">Tentar novamente</button>
    </div>
  </div>
</template>

<script>
import NewsCarousel from '../components/NewsCarousel.vue'
import NewsGrid from '../components/NewsGrid.vue'
import { getAllNews, getCarouselNews } from '../data/newsData'

export default {
  name: 'HomeView',
  components: {
    NewsCarousel,
    NewsGrid
  },
  data() {
    return {
      carouselNews: [],
      allNews: [],
      errorMessage: '',
      isLoading: true
    }
  },
  created() {
    this.loadNews()
  },
  methods: {
    async loadNews() {
      this.errorMessage = ''
      this.isLoading = true
      try {
        const [allNewsResult, showCarouselResult] = await Promise.allSettled([
          getAllNews(),
          getCarouselNews(5)
        ])

        const allNews = allNewsResult.status === 'fulfilled' ? (allNewsResult.value || []) : []
        const carouselHighlights = showCarouselResult.status === 'fulfilled' ? (showCarouselResult.value || []) : []

        const hasFailure = allNewsResult.status === 'rejected' || showCarouselResult.status === 'rejected'

        if (hasFailure) {
          throw allNewsResult.reason || showCarouselResult.reason || new Error('Falha ao carregar notícias')
        }

        this.allNews = allNews
        this.carouselNews = carouselHighlights
      } catch (error) {
        console.error('Erro ao carregar notícias', error)
        this.errorMessage = 'Falha na comunicação com o servidor.'
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.home-view {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 7vw;
}

.home-error {
  text-align: center;
  padding: 4rem 2rem;
  border-radius: 16px;
  background: rgba(0, 35, 73, 0.035);
  color: var(--brand-cloud);
  box-shadow: 0 30px 50px rgba(0, 35, 73, 0.08);
}

.home-error h2 {
  color: var(--brand-cloud);
  margin-bottom: 1rem;
}

.retry-btn {
  margin-top: 1.5rem;
  padding: 0.8rem 1.8rem;
  border: 1px solid rgba(229, 233, 253, 0.65);
  border-radius: 999px;
  background: var(--brand-navy);
  color: #f5f8ff;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 18px 35px rgba(0, 35, 73, 0.25);
}

.retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 24px 45px rgba(0, 35, 73, 0.32);
}

@media screen and (max-width: 700px) {
  .home-view {
    margin-top: 0;
  }

  .home-error {
    padding: 0;
    min-height: 0;
  }
}
</style>
